import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TextField, Card, CardContent, CardMedia, Typography, Chip } from '@mui/material';
import { Color } from '../../../assets/color';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const MediaCoverage = () => {
    const [mode, setMode] = useState('');
    const dispatch = useDispatch();
    const { mediaCoverageData } = useSelector(state => state?.superadminReducer);

    const [inputFieldDetail, setInputFieldDetail] = useState({
        title: '', description: '', image: '', source_url: '', source_name: '', date: '', priority: 0
    });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });
    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value }));

    const handleReset = () => {
        setInputFieldDetail({ title: '', description: '', image: '', source_url: '', source_name: '', date: '', priority: 0 });
        setMode('');
    };

    const handleEdit = (data) => {
        setInputFieldDetail({
            title: data?.title || '',
            description: data?.description || '',
            image: data?.image || '',
            source_url: data?.source_url || '',
            source_name: data?.source_name || '',
            date: data?.date ? data.date.split('T')[0] : '',
            priority: data?.priority || 0,
            id: data?._id
        });
        setMode('Edit');
    };

    const handleSubmit = () => {
        if (!inputFieldDetail.title) {
            handleInputFieldDetailError('title', 'Title is required');
            return;
        }

        const formData = new FormData();
        formData.append('title', inputFieldDetail.title);
        formData.append('description', inputFieldDetail.description);
        formData.append('source_url', inputFieldDetail.source_url);
        formData.append('source_name', inputFieldDetail.source_name);
        formData.append('date', inputFieldDetail.date);
        formData.append('priority', inputFieldDetail.priority);

        if (inputFieldDetail.imageFile) {
            formData.append('image', inputFieldDetail.imageFile);
        }

        if (mode === 'Edit') {
            dispatch(SuperadminActions.updateMediaCoverage({
                id: inputFieldDetail?.id,
                data: formData,
                onComplete: () => handleReset()
            }));
        } else {
            dispatch(SuperadminActions.createMediaCoverage({
                data: formData,
                onComplete: () => handleReset()
            }));
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setInputFieldDetail(prev => ({
                ...prev,
                imageFile: file,
                image: URL.createObjectURL(file)
            }));
        }
    };

    useEffect(() => {
        dispatch(SuperadminActions.getMediaCoverage());
    }, []);

    return (
        <>
            <RouteHeader title="Media Coverage" sub_title="Manage media coverage section for the website" />

            <div style={{ backgroundColor: Color.white, padding: '20px', borderRadius: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title="Media Coverage Management" sub_title="Add, update, or delete media coverage entries" />
                    <div onClick={() => setMode(mode ? '' : 'Add')} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>
                        {mode ? 'Cancel' : 'Add New Coverage'}
                    </div>
                </div>

                {mode && (
                    <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                        <Grid item lg={6} sm={12} md={6} xs={12}>
                            <TextField label="Title" variant="outlined" fullWidth
                                name="title"
                                value={inputFieldDetail?.title}
                                onChange={handleInputFieldDetail}
                                error={!!inputFieldError.title}
                                helperText={inputFieldError.title}
                                onFocus={() => handleInputFieldDetailError("title", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={3} sm={12} md={3} xs={12}>
                            <TextField label="Source Name (e.g., Times of India)" variant="outlined" fullWidth
                                name="source_name"
                                value={inputFieldDetail?.source_name}
                                onChange={handleInputFieldDetail}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={3} sm={12} md={3} xs={12}>
                            <TextField label="Source URL" variant="outlined" fullWidth
                                name="source_url"
                                value={inputFieldDetail?.source_url}
                                onChange={handleInputFieldDetail}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <TextField label="Description" variant="outlined" fullWidth multiline rows={3}
                                name="description"
                                value={inputFieldDetail?.description}
                                onChange={handleInputFieldDetail}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={4} sm={12} md={4} xs={12}>
                            <TextField label="Date" variant="outlined" fullWidth type="date"
                                name="date"
                                value={inputFieldDetail?.date}
                                onChange={handleInputFieldDetail}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={4} sm={12} md={4} xs={12}>
                            <TextField label="Priority" variant="outlined" fullWidth type="number"
                                name="priority"
                                value={inputFieldDetail?.priority}
                                onChange={handleInputFieldDetail}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item lg={4} sm={12} md={4} xs={12}>
                            <TextField label="Image" variant="outlined" fullWidth type="file"
                                onChange={handleImageChange}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: 'image/*' }}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <div onClick={handleReset} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '14px', cursor: 'pointer' }}>Cancel</div>
                                </Grid>
                                <Grid item>
                                    <div onClick={handleSubmit} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: Color.white, fontSize: '14px', cursor: 'pointer' }}>{mode} Coverage</div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    {mediaCoverageData?.map((value, index) => (
                        <Grid item key={index} lg={4} md={6} sm={12} xs={12}>
                            <Card elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                {value?.image && (
                                    <CardMedia
                                        component="img"
                                        height="180"
                                        image={value?.image}
                                        alt={value?.title}
                                        sx={{ objectFit: 'cover' }}
                                    />
                                )}
                                <CardContent>
                                    <Typography variant="subtitle1" fontWeight="600" gutterBottom className='line-clamp-1'>
                                        {value?.title}
                                    </Typography>
                                    {value?.source_name && (
                                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                            Source: {value?.source_name}
                                        </Typography>
                                    )}
                                    <Typography variant="body2" color="text.secondary" className='line-clamp-2' sx={{ mt: 1 }}>
                                        {value?.description}
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '10px' }}>
                                        <Chip label={value?.status ? 'Active' : 'Inactive'} size="small"
                                            sx={{ backgroundColor: value?.status ? '#e8f5e9' : '#fbe9e7', color: value?.status ? '#2e7d32' : '#d84315' }}
                                        />
                                        {value?.date && <Chip label={new Date(value.date).toLocaleDateString()} size="small" variant="outlined" />}
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-start', marginTop: '15px' }}>
                                        <div onClick={() => handleEdit(value)} style={{ padding: '4px 15px 3px 15px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '12px', cursor: 'pointer' }}>Edit</div>
                                        <div onClick={() => dispatch(SuperadminActions.changeMediaCoverageStatus({ id: value?._id }))} style={{ padding: '4px 15px 3px 15px', border: `1px solid #FFA500`, borderRadius: '5px', backgroundColor: '#FFF8E1', color: '#FFA500', fontSize: '12px', cursor: 'pointer' }}>
                                            {value?.status ? 'Deactivate' : 'Activate'}
                                        </div>
                                        <div onClick={() => dispatch(SuperadminActions.deleteMediaCoverage({ id: value?._id }))} style={{ padding: '4px 15px 3px 15px', border: `1px solid ${Color.red}`, borderRadius: '5px', backgroundColor: Color.red, color: Color.white, fontSize: '12px', cursor: 'pointer' }}>Delete</div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </>
    );
};

export default MediaCoverage;
